import { render, staticRenderFns } from "./EditClient.vue?vue&type=template&id=f0a412fc&scoped=true"
import script from "./EditClient.vue?vue&type=script&lang=js"
export * from "./EditClient.vue?vue&type=script&lang=js"
import style0 from "./EditClient.vue?vue&type=style&index=0&id=f0a412fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a412fc",
  null
  
)

export default component.exports